const SET = 'patron/location/SET';

export default {
  SET,
};
